import React from "react";

const TextAreaField = ({ label, value, onChange, ...props }) => (
  <div className="relative mb-4 flex w-full flex-col items-end">
    <label className="font-semibold text-lg mb-4">{label}</label>
    <textarea
      dir="rtl"
      value={value}
      onChange={onChange}
      {...props}
      className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
    >
      {value}
    </textarea>
  </div>
);

export default TextAreaField;
